define('app/views/cart_submit_button_view',['app/setup'], function(takhfifan) {
  takhfifan.CartSubmitButtonView = Backbone.View.extend({
    events: {
      'click' : 'submitToCheckout',
    },
    initialize: function() {
    },
    submitToCheckout: function() {
      var submitpath = this.$el.data('submitpath'),
          data = $('#cart-form').serializeArray(),
          params = {},
          _this = this;

      $.each(data,function(idx,item){
        params[item.name] = item.value;
      });

      this.$el.html('<span class="spinner"></span>');
      $('.tkh-cart-submit-btn').attr('disabled', true);

      $.post(submitpath, params).done(function(data){
        try {
          var dataObj = JSON.parse(data);
        } catch(err) {
          takhfifan.airbrake.notify(err);
        }
        if(dataObj && dataObj.result === "ok") {
          window.location.href = submitpath;
        }
        else {
          window.location.reload();
        }
      }).fail(function(data){
        window.location.reload();
        _this.$el.html('نهایی کردن خرید<span class="icon-arrow-back"></span>');
        $('.tkh-cart-submit-btn').attr('disabled', false);
      });
    }
  });
});

